(function () {
  'use strict';

  // Kun aktiv på mobile breakpoint
  var mqMobile = window.matchMedia('(max-width: 767px)');

  function setupSlider(slider) {
    if (slider.__pcardInit) return;
    slider.__pcardInit = true;

    // Spring over hvis kortet ligger inde i en parent horizontal slider
    // (featured-collection, recently-viewed, cart-recommendations etc.) —
    // ellers konflikter touch gestures med parent-sliderens swipe.
    if (slider.closest('.swiper-wrapper, .sf__ms-wrapper, .sf__ms, .sf__ms--slider')) return;

    var container = slider.querySelector('[data-pcard-slides-container]');
    var indicator = slider.querySelector('[data-pcard-progress-indicator]');
    var totalSlides = parseInt(slider.getAttribute('data-pcard-slides'), 10) || 1;
    if (!container || !indicator || totalSlides < 2) return;

    var raf;
    function update() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var slideWidth = container.offsetWidth;
        var maxScroll = container.scrollWidth - slideWidth;
        if (maxScroll <= 0) {
          indicator.style.transform = 'translateX(0)';
          return;
        }
        var progress = container.scrollLeft / maxScroll; // 0..1
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        // Flyt indikatoren proportionalt — fra 0 til (totalSlides - 1) gange dens egen bredde
        var translatePercent = progress * (totalSlides - 1) * 100;
        indicator.style.transform = 'translateX(' + translatePercent + '%)';
      });
    }

    container.addEventListener('scroll', update, { passive: true });
    update();

    // Reset til første slide når et variant-swatch klikkes
    var card = slider.closest('[data-view="card"]');
    if (card) {
      card.addEventListener('click', function (e) {
        var swatch = e.target.closest('[data-pcard-swatch], .product-option-item, .sf__pcard-swatch');
        if (swatch) {
          container.scrollTo({ left: 0, behavior: 'auto' });
        }
      });
    }
  }

  function init() {
    if (!mqMobile.matches) return;
    var sliders = document.querySelectorAll('[data-pcard-slider]:not([data-pcard-init])');
    if (!sliders.length) return;

    // IntersectionObserver — wire kun cards der nærmer sig viewport
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setupSlider(entry.target);
            entry.target.setAttribute('data-pcard-init', '1');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });

      sliders.forEach(function (s) { io.observe(s); });
    } else {
      sliders.forEach(setupSlider);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init når nye cards injiceres (recently-viewed, recommendations etc.)
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      // debounce — én init per tick
      if (mo.__pending) return;
      mo.__pending = true;
      setTimeout(function () { mo.__pending = false; init(); }, 100);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
